import React from "react";
import { NavLink } from "react-router-dom";
import {
  AccountBalanceWallet,
  Assessment,
  Dashboard,
  Inventory,
  Paid,
  Payments,
  People,
  PhoneIphone,
  Savings,
  Security,
  Settings,
} from "@mui/icons-material";
import { useAuth } from "../../context/AuthContext";
import { canAudit, canManageUsers, canUseFunds, canUseReports, canUseTreasury } from "../../utils/access";

const menu = [
  { to: "/dashboard", label: "Dashboard", icon: Dashboard },
  { to: "/clients", label: "Clients", icon: People },
  { to: "/products", label: "Produits", icon: Inventory },
  { to: "/investments", label: "Investissements", icon: Paid },
  { to: "/recoveries", label: "Recouvrements", icon: Payments },
  { to: "/treasury", label: "Tresorerie", icon: AccountBalanceWallet, permission: canUseTreasury },
  { to: "/funds", label: "Fonds", icon: Savings, permission: canUseFunds },
  { to: "/reports", label: "Rapports", icon: Assessment, permission: canUseReports },
  { to: "/audit", label: "Controle", icon: Security, audit: true },
  { to: "/users", label: "Utilisateurs", icon: Settings, permission: canManageUsers },
  { to: "/mobile", label: "Mobile", icon: PhoneIphone },
];

function Sidebar() {
  const { user } = useAuth();
  const isAuditAllowed = canAudit(user);



  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <span className="sidebar-brand__shield">
          <img src="/OWSUR.png" className="sidebar-brand__img" alt="Client" />
        </span>
        <div>
          <strong>OWSUR</strong>
          <small>Capital Investment</small>
        </div>
      </div>
      <div className="sidebar-section">
        {menu
          .filter((item) => (!item.permission || item.permission(user)) && (!item.audit || isAuditAllowed))
          .map((item) => {
            const Icon = item.icon;
            return (
              <NavLink key={item.to} to={item.to} className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}>
                <Icon />
                <span>{item.label}</span>
              </NavLink>
            );
          })}
      </div>
      <div className="sidebar-status">
        <span />
        <div>
          <strong>Système opérationnel</strong>
          <small>Tous les modules sont actifs</small>
        </div>
      </div>
    </aside>
  );
}

export default Sidebar;
